const DigitalDepotAccountSearchKeysEnum = Object.assign({
  DDA_ID: { text: 'DDA ID', value: 'id' },
  USER_ID: { text: 'User ID', value: 'userId' },
});

Object.freeze(DigitalDepotAccountSearchKeysEnum);

export default DigitalDepotAccountSearchKeysEnum;



// WEBPACK FOOTER //
// ./src/enum/digitalDepots/DigitalDepotAccountSearchKeys.js